module.exports = __webpack_public_path__ + "img/Pack_control_Diabète.8dd7cff6.jpg";